export default {
  locations: [],
  accounts: [],
  bookers: [],
  destinationAccessorials: [],
  quotes: [],
  preferences: [],
  metrics: {},
  allServices: [],
  originAccessorials: [],
  rate: null,
  graph: null,
  providers: [],
  financeItems: []
}



// WEBPACK FOOTER //
// ./src/modules/quote/store/state.js